
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import TextEditor from "./pages/TextEditor";
import AdminRoute from "./components/AdminRoute";
import BodyContent from "./pages/BodyContent";
import Footer from './components/Footer';
import { Box } from "@mui/material";
import Home from "./pages/Home"
import ContentInfo from "./pages/ContentInfo";
import CourseCurriculum from "./pages/CourseCurriculum";
import RegisterLanding from "./pages/RegisterLanding";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import OnlineCodePlayground from "./components/OnlineCodePlayground"
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser, setToken } from "./features/auth/authSlice";
import { getCurrentUser } from "./features/auth/authApi";
import { useLocation } from "react-router-dom";
import { setupSessionCheck } from "./utils/sessionUtils";

const PortfolioRedirect = () => {
  useEffect(() => {
    window.location.href = '/portfolio/index.html';
  }, []);
  return null;
};

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const loggedIn = params.get("logged_in");
    const token = params.get("token");

    // ✅ Centralized session fetcher
    const fetchSession = async () => {
      try {
        const user = await getCurrentUser(); // calls FastAPI /me
        if (user && !user.error) {
          dispatch(setUser(user));
          console.log("✅ Session active:", user.username);
        }
      } catch (err) {
        console.warn("ℹ️ No active session");
      }
    };

    // 1️⃣ Handle Google Login Redirect
    if (loggedIn) {
      if (token) {
        dispatch(setToken(token));
        console.log("✅ Token received from Google OAuth:", token);
      }
      fetchSession().then(() => {
        // Clean up URL parameters without refreshing
        const url = new URL(window.location);
        url.searchParams.delete("logged_in");
        url.searchParams.delete("token");
        window.history.replaceState({}, document.title, url.toString());
      });
    }

    // 2️⃣ Initial check if user is supposed to be logged in but state is empty
    if (!loggedIn && localStorage.getItem("user") && !localStorage.getItem("token")) {
      // Logic for OAuth users who might have lost state but still have session cookie
      fetchSession();
    }

    // 3️⃣ Set up periodic session validation (includes initial check)
    const cleanup = setupSessionCheck(dispatch);

    return cleanup;
  }, [dispatch]);
  return (
    <Box
    // sx={{
    //     display: "flex",
    //     flexDirection: "column",
    //     minHeight: "100vh",
    //     overflowY: "auto",
    //         maxHeight: "calc(100vh - 180px)", // 👈 Adjust for Navbar + Footer height
    //         "&::-webkit-scrollbar": {
    //             width: "6px",
    //         },
    //         "&::-webkit-scrollbar-thumb": {
    //             backgroundColor: "#888",
    //             borderRadius: "6px",
    //         },
    //         "&::-webkit-scrollbar-thumb:hover": {
    //             backgroundColor: "#555",
    //         },
    //         "&::-webkit-scrollbar-track": {
    //             background: "#f1f1f1",
    //         },
    // }}
    >
      {/* Sticky Navbar - Hidden on Register Landing */}
      {location.pathname !== "/register-now" && (
        <Box sx={{ position: "sticky", top: 0, zIndex: 200 }}>
          <Navbar />
        </Box>
      )}

      {/* Scrollable content */}
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <Routes>
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <TextEditor />
              </AdminRoute>
            }
          />
          <Route path="/practice" element={<OnlineCodePlayground />} />
          <Route path="/rkchy23" element={<PortfolioRedirect />} />
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/register-now" element={<RegisterLanding />} />
          <Route path="/curriculum/:slug" element={<CourseCurriculum />} />
          <Route path="/info/:subjectParam/:contentId" element={<ContentInfo />} />
          <Route path="/:subjectParam" element={<BodyContent />} />
          <Route path="/:subjectParam/:contentId" element={<BodyContent />} />
        </Routes>
      </Box>

      {/* Footer - Hidden on Register Landing, Practice, and Course Reader pages */}
      {location.pathname !== "/register-now" && 
       location.pathname !== "/practice" &&
       !Boolean(location.pathname.match(/^\/(python|fastapi|dsa|agentic-ai|html|css|javascript|sql)(\/|$)/i)) && 
       <Footer />}
    </Box>

  );
}

export default App;
